// extracted by mini-css-extract-plugin
export default {"GradientBackground":"GradientBackground_GradientBackground__tFjrm"};